module.exports = __webpack_public_path__ + "style/img/bz1.4d5132fc.jpg";